import GenericDB from './generic-db';

export default class ChartFavoritesDB extends GenericDB {
  constructor() {
    super('chartFavorites');
  }

  // Here you can extend ChartFavoritesDB with custom methods
}
